import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20819 29999"
    {...props}
  >
    <path
      d="M984 7663c0-1331 362-2588 1093-3770 724-1181 1789-2124 3196-2835C6681 355 8327 0 10211 0c1585 0 2979 205 4181 621 1202 410 2199 984 3005 1708 799 731 1394 1551 1776 2459 390 915 581 1885 581 2917 0 1304-335 2472-1011 3497-670 1024-1680 1865-3012 2520 1133 437 2076 1018 2820 1728 752 718 1319 1544 1694 2480 383 942 574 1988 574 3128 0 1680-410 3204-1222 4570-813 1366-2008 2438-3580 3210-1577 772-3435 1161-5566 1161-2214 0-4112-389-5683-1161-1578-772-2766-1838-3566-3190C403 24296 0 22779 0 21099c0-3586 1694-6045 5089-7377-2739-1277-4105-3299-4105-6059zm14344 13238c0-1038-212-1947-642-2718-424-779-1025-1374-1797-1783-772-417-1639-622-2602-622-1360 0-2493 451-3416 1359-921 909-1379 2179-1379 3805 0 1045 218 1960 649 2753 437 792 1024 1407 1769 1844 744 430 1578 649 2500 649 936 0 1769-219 2520-663 745-437 1332-1058 1756-1858 430-806 642-1721 642-2766zM10328 3811c-1250 0-2261 389-3026 1175-765 779-1148 1783-1148 3012 0 1134 390 2084 1175 2835 786 758 1804 1134 3040 1134 628 0 1195-103 1708-301 512-198 956-478 1317-833 369-355 657-772 855-1264 198-485 300-1024 300-1612 0-785-178-1495-533-2124-348-628-847-1120-1489-1482-635-362-1373-540-2199-540z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
